import { MAT_CARD_CONFIG } from '@angular/material/card';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

export const splMaterialProviders = [
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: { appearance: 'outline' },
  },
  {
    provide: MAT_CARD_CONFIG,
    useValue: { appearance: 'raised' },
  },
  {
    provide: MAT_DATE_LOCALE,
    useValue: 'en-GB',
  },
  provideNativeDateAdapter(),
];
